import React from 'react';
import { ModalSwitchCashier } from '../../../components/cash-register/modals/modal-switch-cashier';

export const CashierSwitchScreen = () => {
  return <ModalSwitchCashier isVisible={true} />;
};
